<template>
  <div class="footer p-xl">
    <ul>
      <li>
        <a :href="imprintLink" target="_blank">Impressum</a>
      </li>
      <li>
        <a :href="privacyLink" target="_blank">Datenschutz</a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
	name: 'app-footer',

	props: {
		imprintLink: {
			type: String,
			default: '',
		},
		privacyLink: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #010101;
  text-align: center;

  a {
    display: block;
    color: #fff;
    text-decoration: none;
    padding: 0.5em 0;
  }
}
</style>
